import styles from './index.module.scss'
import { Switch, Popover, Slider } from 'antd';
import { GenerateContext } from "../../../hooks/GenerateContext"
import { useContext, useState, useEffect, useRef } from "react"
import { QuestionCircleOutlined } from '@ant-design/icons';

const Relight = (props) => {
    const {
        relight, setRelight
    } = useContext(GenerateContext)
    const [checkedVal, setCheckedVal] = useState(false)

    useEffect(() => {
        setCheckedVal(relight > 0)
    }, [relight])


    return (
        <div className={styles.RelightWrap}>
            <div className={styles.Relight}>
                <div className={styles.title}>光影融合
                    <Popover content={'开启后光影细节会更精致，但将增加生成时间'}>
                        <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                    </Popover>
                </div>
                <div className={styles.switch}><Switch style={{ marginRight: 8 }}
                    checked={checkedVal}
                    onChange={(v) => {
                        setCheckedVal(v)
                        setRelight(v ? 1.0 : 0.0)
                    }}/>{checkedVal ? '开启' : '关闭'}</div>
            </div>
            {
                relight > 0.0 && <div className={styles.SliderWrap}>
                    <span>强度</span>
                    <Slider className={styles.Slider} max={1.5} min={0.7} value={relight} step={0.1} onChange={value => setRelight(value)} />
                    <span>{relight.toFixed(1)}</span>
                </div>
            }
        </div>
    )
}


export default Relight